import React, { useState, useEffect, useCallback } from 'react';
import { format } from "date-fns";
import Header from '../../components/Header';
import "./PurchaseSummary.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessNotification from '../../components/Notifications/SuccessNotification';
import ErrorNotification from '../../components/Notifications/ErrorNotification';
import WarningNotification from '../../components/Notifications/WarningNotification';
import LoginNotification from "../../components/Notifications/LoginNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import NotificationConnectionKpi from '../../components/Notifications/NotificationConnectionKpi';
import { faCircleArrowLeft, faDollarSign, faCheck, faBasketShopping, faXmark, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import Table from '../../components/Table';
import Section from '../../components/Section';
import apiClient from "../../axios";
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Loader from "../../components/Loader";

const PurchaseSummary = ({ handleLogout }) => {
    const { orderNumber } = useParams();
    const [data, setData] = useState([]);
    const location = useLocation();
    const [balance, setBalance] = useState(0);
    const distributorToken = localStorage.getItem('distributor');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [totalCompra, setTotalCompra] = useState(0);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isWarnningVisible, setIsWarnningVisible] = useState(false);
    const navigate = useNavigate();
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [isSuccessProcessVisible, setIsSuccessProcessVisible] = useState(false);
    const [notificationBlock, SetNotificationBlock] = useState(false);
    const [file, setFile] = useState(null);
    const token = localStorage.getItem('token');
    const miBaseURL = apiClient.defaults.baseURL;
    const [mensage, setMensaje] = useState("");
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [cli, setCli] = useState(null);
    const [isContract] = useState(location.state?.isContract || false);
    const [orderData, setOrderData] = useState({
        numSerie: "",
        cliente: "",
        servidor: "",
        tipocontra: "",
        contEmpre: "",
        observacion: "",
        tipoContrato: "",
        distribuidor: "",
        clientName: ""
    });
    const [saleData, setSaleData] = useState({
        contractId: "",
        total: 0,
        subtotal: 0,
        taxPercentage: 0,
        taxes: 0,
        distributorName: "",
        userName: ""
    });
    const [isWhatsApp, setIsWhatsApp] = useState("");
    const [ruc, setCif] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [name, setNombre] = useState("");
    const [lastName, setApellido] = useState("");
    const [email, setEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmarClave, setConfirmarClave] = useState("");
    const [userName, setUserName] = useState("");
    const contract = process.env.REACT_APP_FENIX_CONTRACT;
    const [moduleTemplatesId, setModuleTemplatesId] = useState("");
    const [planId, setPlanId] = useState(0);
    const [month, setMonth] = useState("");
    const [mensaje2, setMensaje2] = useState(0);
    const [isSuccessNotifVisible, setIsSuccessNotifVisible] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isWarningVisible, setIsWarningVisible] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const [messageBlock, setMessageBlock] = useState("");
    const [isSuccessProcessWhatsVisible, setIsSuccessWhatsProcessVisible] = useState(false);


    const handleCloseSuccess = () => {
        setIsSuccessProcessVisible(false);
    };

    const handleCloseWhatsSuccess = () => {
        setIsSuccessWhatsProcessVisible(false);
        setIsSuccessNotifVisible(true);
    };

    const handleCloseBlock = () => {
        SetNotificationBlock(false);
    };

    useEffect(() => {
        // Función para cargar datos de la orden
        const fetchOrderData = async () => {
            try {
                const response = await apiClient.get(`/orders/${orderNumber}`);
                const data = response.data.contractData;
                setOrderData({
                    numSerie: data.numSerie || '',
                    cliente: data.cliente || '',
                    servidor: data.servidor || '',
                    tipocontra: data.productType || '',
                    contEmpre: data.contEmpre || '',
                    observacion: data.observacion || '',
                    tipoContrato: data.contractType || '',
                    clientName: data.clientName || '',
                });
                const cl = await apiClient.get(`/clients?search=${data.cliente}`);
                setCli(cl.data[0])
                const dataSale = response.data;
                setSaleData({
                    contractId: dataSale.contractId || '',
                    total: dataSale.total || 0,
                    subtotal: dataSale.subtotal || 0,
                    taxPercentage: dataSale.taxPercentage || 0,
                    taxes: dataSale.taxes || 0,
                    distributorName: dataSale.distributorName || '',
                    userName: dataSale.userName || '',
                });
                setTotalCompra(dataSale.total);
                const modules = response.data.orderItems;
                const polizaItem = modules.find(item => item.productType === "POLIZAS");
                if (polizaItem) {
                    try {
                        const comboDetail = await apiClient.get(`/comboModule?search=${polizaItem.productId}`);
                        const comboResponse = comboDetail.data
                        const whatsappCombo = comboResponse.find(item => item.moduleCode === "WHATSAPP");
                        if (whatsappCombo) {
                            setIsWhatsApp(whatsappCombo.moduleCode);
                            setModuleTemplatesId(whatsappCombo.whatsappTemplateId);
                            const response2 = await apiClient.get(`/module_pack/${whatsappCombo.whatsappTemplateId}`);
                            const whatsAppData = response2.data;
                            if (Array.isArray(whatsAppData) && whatsAppData.length > 0) {
                                setMonth(whatsAppData[0].paymentPeriod);
                                setPlanId(whatsAppData[0].makiSubscriptionsId);
                            }
                        }
                    } catch (error) {
                        console.error("Error al obtener los datos del modulo:", error);
                    }
                }
                try {
                    const response = await apiClient.get(`/distributors/${distributorToken}/debt`);
                    if (response.data) {
                        setBalance(response.data.cuponCredit);
                    }
                } catch (error) {
                    setBalance(error.response.data.availableBalance);
                    if (error.response && error.response.status === 400) {
                        setBalance(error.response.data.availableBalance);
                    }
                }
            } catch (error) {
                console.error("Error al obtener los datos de la orden:", error);
            }
        };
        fetchOrderData();
    }, [orderNumber, distributorToken]);

    const fetchAllData = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/orders/${orderNumber}`);
            const orderItems = response.data.orderItems;
            if (Array.isArray(orderItems)) {
                setData(orderItems);
                setTotalItems(orderItems.length);
                setIsWhatsApp(orderItems[0].code);
                if (orderItems[0].code === "WHATSAPP") {
                    setModuleTemplatesId(orderItems[0].moduleTemplateId);
                    setMonth(orderItems[0].paymentPeriod);
                    const response2 = await apiClient.get(`/module_pack/${orderItems[0].moduleTemplateId}`);
                    const whatsAppData = response2.data;
                    if (Array.isArray(whatsAppData) && whatsAppData.length > 0) {
                        setPlanId(whatsAppData[0].makiSubscriptionsId);
                    }
                }
            }
        } catch (error) {
            setIsErrorVisible(true);
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        } finally {
            setLoading(false);
        }
    }, [orderNumber]);

    useEffect(() => {
        fetchAllData(currentPage);
        //console.log(location.state?.isContract);
    }, [currentPage, fetchAllData]); // Agregado fetchAllData como dependencia

    const handleRefresh = () => {
        fetchAllData(currentPage);
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!file) {
            validationErrors.file = "El Campo es Obligatorio";
        } else {
            const validTypes = ["application/pdf", "image/png", "image/jpeg"];
            if (!validTypes.includes(file.type)) {
                validationErrors.file = "El archivo debe ser un PDF, PNG, JPG o JPEG";
            }
        }

        return validationErrors;
    };

    // Maneja el cambio del archivo
    const handleFileChange = (event) => {
        setFile(event.target.files[0]); // Guarda el archivo en el estado
    };

    //VALIDACIONE WHATSAPP
    const fetchAuthToken = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_CIFRUC_URL}/login`,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Basic " + btoa("fenix:7&m$T8v_12d6?aA}yVOF"),
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Error al obtener el token");
            }

            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error("Error al obtener el token:", error);
            return null;
        }
    };

    const handleDocumentSearch = async (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            event.preventDefault();
            try {
                // Obtén el token primero
                setLoading(true);
                const token = await fetchAuthToken();
                if (!token) {
                    throw new Error("No se pudo obtener el token de autenticación");
                }
                const response = await fetch(
                    `${process.env.REACT_APP_CIFRUC_URL}/document/search`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            contract: contract,
                            document: ruc,
                        }),
                    }
                );
                if (!response.ok) {
                    throw new Error("Error en la búsqueda del documento");
                }
                const data = await response.json();
                if (data.document && data.document.socialReason) {
                    setIsWarningVisible(false);
                    setIsErrorVisible(false);
                    setIsButtonDisabled(false);
                    const palabras = data.document.socialReason.trim().split(/\s+/);
                    const apellido = palabras.slice(0, 2).join(" ");
                    const nombre = palabras.slice(-2).join(" ");
                    setApellido(apellido);
                    setNombre(nombre);
                }
                if (data.document && data.document.email) {
                    setEmail(data.document.email);
                } else {
                    setEmail("");
                }
            } catch (error) {
                setErrorMessage(
                    "El Documento de Identificación ingresado es Incorrecto o No Existe."
                );
                setIsErrorVisible(true);
                setIsButtonDisabled(true);
                if (ruc.length === 10 && /^[0-9]+$/.test(ruc)) {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                } else if (ruc.length === 13 && /^[0-9]+$/.test(ruc)) {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                } else if (/[^0-9]/.test(ruc)) {
                    setWarningMessage(
                        "El Documento de Identificación ingresado es un Pasaporte."
                    );
                    setIsWarningVisible(true);
                    setIsButtonDisabled(false);
                }

            } finally {
                setLoading(false);
            }
        }
    };
    const handleCifChange = (e) => {
        const value = e.target.value;
        setCif(value);
        if (value === "") {
            setNombre("");
            setApellido("");
            setEmail("");
            setIsWarningVisible(false);
            setIsErrorVisible(false);
            setIsButtonDisabled(false);
        }
    };

    const validateEmail = (email) => {
        // Expresión regular para validar el formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email); // Solo valida el formato del correo
    };
    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        // Validar el email
        if (!validateEmail(value)) {
            setErrors({
                email: 'Email inválido. Debe contener "@" y un dominio válido.',
            });
        } else {
            setErrors({});
        }
    };
    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleShowPassword2 = () => {
        setShowPassword2((prevShowPassword) => !prevShowPassword);
    };

    const validateFieldsWhatsApp = () => {
        let validationErrors = {};
        if (!ruc) validationErrors.ruc = "El Campo es Obligatorio";
        if (!phoneNumber) validationErrors.phoneNumber = "El Campo es Obligatorio";
        if (!name) validationErrors.name = "El Campo es Obligatorio";
        if (!lastName) validationErrors.lastName = "El Campo es Obligatorio";
        if (!email) validationErrors.email = "El Campo es Obligatorio";
        if (!userName) validationErrors.userName = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (password !== confirmarClave) {
            validationErrors.confirmarClave = "Las claves no coinciden";
        }
        return validationErrors;
    };
    const isHandleCloseSuccess = () => {
        setIsSuccessNotifVisible(false);
        navigate(-1);
    };

    const handleConfirm = async (event) => {
        if (isWhatsApp === "WHATSAPP") {
            const validationErrors = validateFieldsWhatsApp();
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                setErrorMessage(
                    "Existen Datos del Plan de WhatsApp obligatorias sin Completar."
                );
                setIsErrorVisible(true);
                return;
            }
        }
        if (totalCompra < balance) {
            event.preventDefault();
            try {
                setLoading(true);
                let response;
                //AQUI VALIDACION
                try {
                    const validateStatusorder = await apiClient.get(`/orders/${orderNumber}`);
                    if (validateStatusorder.status === 200) {
                        if (validateStatusorder.data?.status !== "Completed") {
                            try {
                                if (orderData.tipoContrato === "Contador") {
                                    const validationErrors = validateFields();
                                    if (Object.keys(validationErrors).length > 0) {
                                        setErrors(validationErrors);
                                        setIsWarnningVisible(true);
                                        return;
                                    }
                                    const formData = new FormData();
                                    formData.append('voucherFile', file);
                                    response = await fetch(`${miBaseURL}/orders/${orderNumber}/purchase`, {
                                        method: 'POST',
                                        headers: {
                                            'Authorization': `Bearer ${token}`, // Agrega el token de autenticación
                                        },
                                        body: formData,
                                    });

                                } else {
                                    response = await apiClient.post(`/orders/${orderNumber}/purchase`);
                                }
                                if (response.status === 200) {
                                    if (orderData.tipoContrato === "Contador") {
                                        setMensaje("El contrato se ha creado correctamente. La Orden esta pediente de aprobar")
                                    }
                                    else {
                                        const newContractNumber = response.data?.contract;
                                        const newInvoiceNumber = response.data?.purchaseData?.invoiceNumber;
                                        setMensaje(`El contrato se ha creado correctamente con Número de Contrato ${newContractNumber} y Factura Número ${newInvoiceNumber}.`)
                                    }
                                    if (isWhatsApp === "WHATSAPP") {
                                        const today = new Date();
                                        const formattedDate = format(today, "yyyy-MM-dd HH:mm:ss");
                                        try {
                                            const payloadWhatsApp = {
                                                moduleTemplatesId: String(moduleTemplatesId),
                                                numCont: saleData.contractId,
                                                userName,
                                                name,
                                                lastName,
                                                password,
                                                email,
                                                phoneNumber: "593" + phoneNumber,
                                                grupo: "user",
                                                platform: "whatsapp",
                                                planId,
                                                month,
                                                ruc,
                                                flagActive: true,
                                                fechaIni: formattedDate
                                            };
                                            response = await apiClient.post("/whatsappDetails", payloadWhatsApp);
                                            if (response.status === 201) {
                                                const register = `Nro. Contrato: ${saleData.contractId}
                              RUC: ${ruc}
                              Razón Social: ${name + " " + lastName}
                              Usuario: ${response.data?.userName}
                               Nro. Celular: ${response.data?.phoneNumber}
                                Contraseña: ${response.data?.password}
                                Token: ${response.data?.token}`;
                                                setMensaje2(register);
                                                setIsSuccessVisible(true);
                                                setIsSuccessWhatsProcessVisible(true);
                                            }
                                        } catch (error) {
                                            if (error.statusCode === 504) {
                                                setMessageBlock(`Existe un problema en la API FENIXWS.`);
                                                SetNotificationBlock(true);
                                            }
                                            else if (error.response && error.response.status === 401) {
                                                setIsLoginVisible(true);
                                            } else if (error.response?.data?.message.startsWith("PHONE_NUMBER_ALREADY_EXIST")) {
                                                setMessageBlock(`No se pude realizar la compra debido a:
                                El Número de Celular ingresado ya existe.`)
                                                SetNotificationBlock(true);

                                            } else if (error.response?.data?.message.startsWith("PHONE_ALREADY_EXISTS")) {
                                                setMessageBlock(`No se pude realizar la compra debido a:
                                El Número de Celular ingresado ya existe.`)
                                                SetNotificationBlock(true);

                                            }
                                            else if (error.response?.data?.message.startsWith("USER_ALREADY_EXIST")) {
                                                setMessageBlock(`No se pude realizar la compra debido a:
                                El Usuario ingresado ya existe.`)
                                                SetNotificationBlock(true);
                                            }
                                            else if (error.response?.data?.message.startsWith("USERNAME_ALREADY_EXISTS")) {
                                                setMessageBlock(`No se pude realizar la compra debido a:
                                El Usuario ingresado ya existe.`)
                                                SetNotificationBlock(true);
                                            }
                                            else {
                                                setErrorMessage("Oops!. Ocurrio un error al crear el Orden");
                                                setIsLoginVisible(false);
                                                setIsErrorVisible(true);
                                                setIsSuccessVisible(false);
                                                setTimeout(() => {
                                                    setIsErrorVisible(false);
                                                }, 4000);
                                            }
                                        }
                                    }
                                    else {
                                        setIsErrorVisible(false);
                                        setIsSuccessVisible(true);
                                        setIsSuccessProcessVisible(true);
                                    }

                                }
                                else if (response.status === 400) {
                                    setIsErrorVisible(true);
                                    if (response.data.errors.error.startsWith("FOR THIS CONTRACT TYPE CLIENT MUST BE ACCOUNTANT CLIENT CODE:")) {
                                        setErrorMessage("El cliente seleccionado no tiene configuración válida para registar contratos de tipo Contador.");
                                    }
                                    else if (response.data.errors.error.startsWith("Error consulta de Id de Facturas: SQL: Column 'ORIGEN' is not found.")) {
                                        setErrorMessage("Error consulta de Id de Facturas: SQL: Column 'ORIGEN' is not found.");
                                    }
                                    setIsSuccessProcessVisible(true);
                                }

                            } catch (error) {
                                setIsErrorVisible(true);
                                if (error.response.status === 504) {
                                    setMessageBlock(`Existe un problema en la API FENIXWS.`);
                                    SetNotificationBlock(true);
                                }
                                else if (error.response && error.response.status === 401) {
                                    setIsLoginVisible(true);
                                } else if (error.response.data.message.startsWith("PRODUCT_NOT_FOUND")) {
                                    setErrorMessage("No se encontró producto.");
                                } else if (error.response.status === 500) {
                                    setErrorMessage("Error interno del servidor (An internal server error occurred)");
                                } else {
                                    setErrorMessage("Existe un problema para confirmar la orden.");
                                }
                            }

                        }
                        else {
                            if (isWhatsApp === "WHATSAPP") {
                                const today = new Date();
                                const formattedDate = format(today, "yyyy-MM-dd HH:mm:ss");
                                try {
                                    const payloadWhatsApp = {
                                        moduleTemplatesId: String(moduleTemplatesId),
                                        numCont: saleData.contractId,
                                        userName,
                                        name,
                                        lastName,
                                        password,
                                        email,
                                        phoneNumber: "593" + phoneNumber,
                                        grupo: "user",
                                        platform: "whatsapp",
                                        planId,
                                        month,
                                        ruc,
                                        flagActive: true,
                                        fechaIni: formattedDate
                                    };
                                    response = await apiClient.post("/whatsappDetails", payloadWhatsApp);
                                    if (response.status === 201) {
                                        const register = `Nro. Contrato: ${saleData.contractId}
                              RUC: ${ruc}
                              Razón Social: ${name + " " + lastName}
                              Usuario: ${response.data?.userName}
                               Nro. Celular: ${response.data?.phoneNumber}
                                Contraseña: ${response.data?.password}
                                Token: ${response.data?.token}`;
                                        setMensaje2(register);
                                        setIsSuccessVisible(true);
                                        setIsSuccessWhatsProcessVisible(true);
                                    }
                                } catch (error) {
                                    if (error.statusCode === 504) {
                                        setMessageBlock(`Existe un problema en la API FENIXWS.`);
                                        SetNotificationBlock(true);
                                    }
                                    else if (error.response && error.response.status === 401) {
                                        setIsLoginVisible(true);
                                    } else if (error.response?.data?.message.startsWith("PHONE_NUMBER_ALREADY_EXIST")) {
                                        setMessageBlock(`No se pude realizar la compra debido a:
                                El Número de Celular ingresado ya existe.`)
                                        SetNotificationBlock(true);

                                    } else if (error.response?.data?.message.startsWith("PHONE_ALREADY_EXISTS")) {
                                        setMessageBlock(`No se pude realizar la compra debido a:
                                El Número de Celular ingresado ya existe.`)
                                        SetNotificationBlock(true);

                                    }
                                    else if (error.response?.data?.message.startsWith("USER_ALREADY_EXIST")) {
                                        setMessageBlock(`No se pude realizar la compra debido a:
                                El Usuario ingresado ya existe.`)
                                        SetNotificationBlock(true);
                                    }
                                    else if (error.response?.data?.message.startsWith("USERNAME_ALREADY_EXISTS")) {
                                        setMessageBlock(`No se pude realizar la compra debido a:
                                El Usuario ingresado ya existe.`)
                                        SetNotificationBlock(true);
                                    }
                                    else {
                                        setErrorMessage("Oops!. Ocurrio un error al crear el Orden");
                                        setIsLoginVisible(false);
                                        setIsErrorVisible(true);
                                        setIsSuccessVisible(false);
                                        setTimeout(() => {
                                            setIsErrorVisible(false);
                                        }, 4000);
                                    }
                                }
                            } else {
                                setErrorMessage("Existe un problema para confirmar la orden.");
                            }
                        }
                    }
                } catch (error) {
                    setMessageBlock(`Existe un problema en la API FENIXWS.`);
                    SetNotificationBlock(true);
                }
            } catch (error) {
                setErrorMessage("Existe un problema para confirmar la orden.");
            }
            finally {
                setLoading(false);
            }
        }
        else {
            setMessageBlock(`El total de su compra supera su cupo disponible, no puede continuar el proceso de compra. 
                    Saldo disponble $${balance} Total de Compra $${totalCompra}.`);
            SetNotificationBlock(true);
        }

    };


    const columns = [
        { title: "Código", key: "code" },
        { title: "Descripción", key: "description" },
        { title: "Precio Modulo", key: "purchasePrice" },
        { title: "Usuarios Extras", key: "extraUsers" },
        { title: "Descuento", key: "dicount" },
        { title: "Total", key: "total" }
    ];

    const renderRow = (item, index) => {
        const subtotal = item.extraUsers * item.perUserPrice + (item.purchasePrice * item.users);
        const total = subtotal - (subtotal * (item.discount / 100));

        return (
            <>
                <td>{item.code}</td>
                <td>
                    {item.users !== 0 ? (
                        <>
                            <div>{item.description} </div>
                        </>
                    ) : (
                        <div>{item.perUserDescription}</div>
                    )}
                </td>
                <td className="align-right">
                    {item.users !== 0 ? (
                        <>
                            <div>${item.purchasePrice.toFixed(2)}</div>
                        </>
                    ) : (
                        <div>-</div>
                    )}
                </td>
                <td className="align-center">
                    {item.extraUsers}
                    <div className="align-center">${item.perUserPrice.toFixed(2)} c/u</div>
                </td>
                <td className="align-right">{item.discount}%</td>
                <td className="align-right">${total.toFixed(2)}</td>
            </>
        )

    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title='Clientes' />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                            // navigate("/Customers");
                            /*if (isContract) {
                                //navigate('/Contract', { state: { customer: cli } });
                                navigate(-1);
                            } else {
                                navigate('/PurchaseList');
                            }*/
                        }}
                    />
                </div>
                <div>
                    <label>ORDEN Nº: {orderNumber} |  CLIENTE: {orderData.clientName} |  CANAL: {saleData.distributorName} |  USUARIO: {saleData.userName} </label>
                </div>
                <div>
                    <label> </label>
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Resumen de la Orden</h3>
                <div className="basic-info-form-grid">
                    {saleData.contractId && (
                        <div className="basic-info-form-group">
                            <label>Nro. Contrato </label>
                            <input
                                type="text"
                                placeholder=" Nro. Contrato"
                                value={saleData.contractId}
                                readOnly
                            />
                        </div>
                    )}
                    <div className="basic-info-form-group">
                        <label>Cliente</label>
                        <input
                            type="text"
                            placeholder="Cliente"
                            value={orderData.cliente}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Servidor</label>
                        <input
                            type="text"
                            placeholder="Servidor"
                            value={orderData.servidor}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label> Nro. Identificador</label>
                        <input
                            type="text"
                            placeholder=" Nro. Identificador"
                            value={orderData.numSerie}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label> Producto</label>
                        <input
                            type="text"
                            placeholder="Producto"
                            value={orderData.tipocontra}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Tipo Contrato</label>
                        <input
                            type="text"
                            placeholder="Tipo Contrato"
                            value={orderData.tipoContrato}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Observación</label>
                        <input
                            type="text"
                            placeholder="Observación"
                            value={orderData.observacion}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Descripción</label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={orderData.contEmpre}
                            readOnly
                        />
                    </div>
                    {orderData.tipoContrato === "Contador" && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.file ? "red" : "revert-layer" }} htmlFor="file">
                                Subir Factura
                            </label>
                            <input type="file" onChange={handleFileChange} />
                            <p className="error-message">{errors.file}</p>
                        </div>
                    )}

                </div>
                {isWhatsApp === "WHATSAPP" && (
                    <>
                        <hr className="divider" />
                        <h3 className="basic-info-form-title">Datos de Usario de WhatsApp</h3>
                        <div className="basic-info-form-grid">
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.ruc ? "red" : "revert-layer" }}>
                                    Documento de Identificación
                                </label>
                                <input
                                    type="text"
                                    placeholder="Documento de Identificación"
                                    value={ruc}
                                    onChange={handleCifChange}
                                    onKeyDown={handleDocumentSearch}
                                />
                                {errors.ruc && <p className="error-message">{errors.ruc}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.name ? "red" : "revert-layer" }}>
                                    Nombre
                                </label>
                                <input
                                    type="text"
                                    placeholder="Nombre"
                                    value={name}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                                {errors.name && <p className="error-message">{errors.name}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.lastName ? "red" : "revert-layer" }}>
                                    Apellido
                                </label>
                                <input
                                    type="text"
                                    placeholder="Apellido"
                                    value={lastName}
                                    onChange={(e) => setApellido(e.target.value)}
                                />
                                {errors.lastName && <p className="error-message">{errors.lastName}</p>}
                            </div>

                            <div className="basic-info-form-group">
                                <label style={{ color: errors?.phoneNumber ? "red" : "revert-layer" }}>Número de Celular</label>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "0 10px",
                                            backgroundColor: "transparent",
                                            border: "1px",
                                            borderRight: "none",
                                            borderRadius: "4px 0 0 4px"
                                        }}
                                    >
                                        <img
                                            src="https://flagcdn.com/w40/ec.png"
                                            alt="EC"
                                            style={{ width: "20px", height: "14px", marginRight: "6px" }}
                                        />
                                        +593
                                    </span>
                                    <input
                                        type="text"
                                        name="numeroCelular"
                                        placeholder="Ej. 987654321"
                                        className="form-control"
                                        style={{ borderRadius: "0 4px 4px 0" }}
                                        value={phoneNumber}
                                        maxLength={9}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,9}$/.test(value)) {
                                                setPhoneNumber(value);
                                            }
                                        }}
                                    />
                                </div>
                                {errors?.phoneNumber && <p className="error-message">{errors.phoneNumber}</p>}
                            </div>

                            <div className="basic-info-form-group">
                                <label style={{ color: errors.email ? "red" : "revert-layer" }}>
                                    {" "}
                                    Email
                                </label>
                                <input
                                    type="text"
                                    placeholder="Email"
                                    value={email}
                                    onChange={handleChange}
                                />
                                {errors.email && <p className="error-message">{errors.email}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.userName ? "red" : "revert-layer" }}>
                                    {" "}
                                    Nombre de Usuario
                                </label>
                                <input
                                    type="text"
                                    placeholder="Nombre de Usuario"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                                {errors.userName && <p className="error-message">{errors.userName}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                                    Clave
                                </label>
                                <div className="password-input-container">
                                    <input
                                        className="text-box-login2"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Contraseña"
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEyeSlash : faEye}
                                        className="password-toggle-icon2"
                                        onClick={toggleShowPassword}
                                    />
                                </div>
                                {errors.password && <p className="error-message">{errors.password}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                                    Confirmar Clave
                                </label>
                                <div className="password-input-container">
                                    <input
                                        className="text-box-login2"
                                        type={showPassword2 ? "text" : "password"}
                                        placeholder="Confirmar Clave"
                                        value={confirmarClave}
                                        onChange={(e) => setConfirmarClave(e.target.value)}
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword2 ? faEyeSlash : faEye}
                                        className="password-toggle-icon2"
                                        onClick={toggleShowPassword2}
                                    />
                                </div>
                                {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
                            </div>

                        </div>


                    </>
                )}

                <div className="mobile-basic-info-form-group">
                    <Table
                        title="Lista de Productos"
                        rows={data}
                        columns={columns}
                        icon={faBasketShopping}
                        renderRow={renderRow}
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={setCurrentPage}
                        onRefresh={handleRefresh}
                        loading={loading}
                        flagPagination={false}
                    />
                </div>
                <div className="basic-form-footer">
                    <div className="basic-footer-container-group ">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FontAwesomeIcon icon={faDollarSign} className="basic-shortcut-icon" />
                            <h3 className="modal-title">Resumen</h3>
                        </div>
                        <table style={{ borderCollapse: 'collapse', width: '30%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                        <label>Subtotal:</label>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid black' }}>
                                        <span>${saleData.subtotal.toFixed(2)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                        <label>Porcentaje IVA:</label>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid black' }}>
                                        <span>{saleData.taxPercentage.toFixed(2)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                        <label>Valor IVA:</label>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid black' }}>
                                        <span>${saleData.taxes.toFixed(2)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                        <label>Total:</label>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid black' }}>
                                        <span>${saleData.total.toFixed(2)}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            //navigate(-2);
                            //handleRefresh();
                            if (isContract) {
                                navigate('/Contract', { state: { customer: cli } });
                            } else {
                                navigate('/PurchaseList');
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button className="basic-custom-button" onClick={handleConfirm} disabled={isButtonDisabled}>
                        <FontAwesomeIcon
                            icon={faCheck}
                            className="basic-shortcut-icon"
                        />
                        Confirmar
                    </button>
                </div>
            </div>
            {loading && <Loader />}
            {isSuccessVisible && (
                <SuccessNotification
                    message="La compra se realizó con éxito."
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
            )}
            {isErrorVisible && (
                <ErrorNotification
                    message={errorMessage}
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
            )}
            {isWarnningVisible && (
                <WarningNotification
                    message="Existe algun error con el archivo de Factura."
                    isVisible={isWarnningVisible}
                    onClose={() => setIsWarnningVisible(false)}
                />
            )}
            {isLoginVisible && (
                <LoginNotification
                    message="La sesión ha expirado."
                    isVisible={isLoginVisible}
                    onClose={() => setIsLoginVisible(false)}
                />
            )}
            {/*Flujo Normal*/}
            {isSuccessProcessVisible && (
                <SuccessProcess
                    message={mensage}
                    isVisible={isSuccessProcessVisible}
                    onClose={handleCloseSuccess}
                    redirectOnOk={true}
                    pageNavigate={"/Customers"}
                    whatsApp={false}
                />
            )}
            {/*Flujo Whats*/}
            {isSuccessProcessWhatsVisible && (
                <SuccessProcess
                    message={mensage}
                    isVisible={isSuccessProcessWhatsVisible}
                    onClose={handleCloseWhatsSuccess}
                    redirectOnOk={false}
                    whatsApp={false}
                />
            )}
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={messageBlock}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={false}
                    whatsApp={false}
                />
            )}
            <NotificationConnectionKpi
                message={`Los datos de conexión son:`}
                men1={mensaje2}  // Pasando men1 como prop
                isVisible={isSuccessNotifVisible}
                onClose={isHandleCloseSuccess}
                enca={false}
            />
            <WarningNotification
                message={warningMessage}
                isVisible={isWarningVisible}
                onClose={() => setIsWarningVisible(false)}
            />
        </div>
    );
};

export default PurchaseSummary;
